import { z } from "zod";
import { zfd } from "zod-form-data";

export const loginSchema = zfd.formData({
  email: zfd.text(
    z
      .string({
        invalid_type_error: "*Information non valide",
        required_error: "*Ce champ est requis.",
      })
      .email("*Information non valide"),
  ),
  password: zfd.text(
    z.string({
      invalid_type_error: "*Information non valide",
      required_error: "*Ce champ est requis.",
    }),
  ),
});

export const loginSchemaI18n = z.object({
  email: z
    .string({ invalid_type_error: "invalid", required_error: "error" })
    .email("invalid"),
  password: z.string({
    invalid_type_error: "invalid",
    required_error: "error",
  }),
});